import "./page-about-us.scss";
import "../../js/core";
import "../../../assets/src/eos/js/video-youtube-iframe";
import "../../components/site-elements/sliders/slider-card-blog/slider-card-blog";
import "../../components/site-elements/sliders/section-slider-partners/section-slider-partners";
import CardTeam from "../../components/site-elements/cards/card-team/card-team";

$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(() => {
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(() => {
        $(".slider-card-team").owlCarousel({
          responsive: {
            0: {
              items: 1,
              dots: false,
            },
            768: {
              items: 2,
              dots: true,
            },
          },
          nav: true,
          dotsEach: true,
          margin: 20,
          smartSpeed: 200,
        });

        $(".slider-card-membership").owlCarousel({
          responsive: {
            0: {
              items: 1,
            },
            568: {
              items: 2,
            },
            1024: {
              items: 3,
            },
            1280: {
              items: 4,
            },
          },
          nav: true,
          dots: false,
          dotsEach: false,
          margin: 20,
          smartSpeed: 200,
        });

        $(".slider-card-priciples").owlCarousel({
          responsive: {
            0: {
              items: 1,
              dots: false,
              nav: true,
              dotsEach: true,
              margin: 20
            },
            768: {
              items: 2,
              dots: true,
              nav: true,
              dotsEach: true,
              margin: 20
            },
            992: {
              items: 0,
              dots: false,
              nav: false,
              dotsEach: false,
              margin: 0
            },
          },
          smartSpeed: 200,
        });

        $(function() {
          $(window).on('resize', function(){
           if($(window).width() <= 991) {
            $('.slider-card-priciples').addClass('owl-carousel');
            }
              else {
            $('.slider-card-priciples').removeClass('owl-carousel');
           }
          }).trigger('resize');
        });

        $(".slider-timeline").owlCarousel({

          responsive: {
            0: {
              items: 3,
              dots: false,
            },
            768: {
              items: 3,
              dots: true,
            },
          },

          center: true,
          nav: true,
          loop: true,
          items: 3,
          dotsEach: true,
          smartSpeed: 0,
          mouseDrag: false,
          touchDrag: false,
          dotsData: true,
          smartSpeed: 200,
        });

        jQuery(".slider-card-blog").owlCarousel({
          responsive: {
            0: {
              items: 1,
              dots: false,
            },
            768: {
              items: 2,
              dots: true,
            },
            992: {
              items: 3,
              dots: true,
            },
          },
          loop: true,
          nav: true,
          dotsEach: true,
          slideBy: 1,
          margin: 20,
          smartSpeed: 200,
        });
        $('.owl-carousel').each(function(index) {
            $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
        });
    });
  });

  CardTeam();
});


$( document ).ready(function() {
  CardTeam();
});

$( window ).on( "resize", function() {
  CardTeam();
  
  $('.card-team').removeClass('active');
} );